import React from 'react';
import { Leaf } from 'lucide-react';
export function Navbar() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="fixed top-0 left-0 right-0 h-20 bg-parchment/90 backdrop-blur-md z-50 border-b border-sage/20 flex items-center justify-between px-6 md:px-12" data-id="element-110">
      <div className="flex items-center text-forest font-playfair font-bold text-xl md:text-2xl cursor-pointer" onClick={() => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} data-id="element-111">
        <Leaf className="w-6 h-6 mr-2 text-sage" data-id="element-112" />
        Botica Natural
      </div>

      {/* Desktop Navigation Links */}
      <nav className="hidden md:flex items-center gap-8 text-brown/80 font-medium" data-id="element-113">
        <button onClick={() => scrollTo('beneficios')} className="hover:text-forest transition-colors" data-id="element-114">
          Beneficios
        </button>
        <button onClick={() => scrollTo('recetas')} className="hover:text-forest transition-colors" data-id="element-115">
          Recetas
        </button>
        <button onClick={() => scrollTo('testimonios')} className="hover:text-forest transition-colors" data-id="element-116">
          Testimonios
        </button>
      </nav>

      <button onClick={() => scrollTo('pricing')} className="bg-amber text-white px-6 py-2.5 rounded-full font-semibold text-sm md:text-base hover:scale-105 transition-transform shadow-md hover:shadow-lg" data-id="element-117">
        Quiero Mi Guía
      </button>
    </header>;
}